import React from 'react'

const Page404: React.FC = () => {
  return <div>404</div>
}

export default Page404
